export const cardData = [

    { 
        icon: 'ti ti-users', 
        bgColor: 'bg-lightsuccess dark:bg-darksuccess', 
        textColor: 'text-success', 
        key: 'totalUser', 
        label: 'Total Itagtip Users' 
    },

    { 
        icon: 'ti ti-layout-grid-add', 
        bgColor: 'bg-lightsuccess dark:bg-darksuccess', 
        textColor: 'text-success', 
        key: 'totalDevices', 
        label: 'Total Devices' 
    },

    { 
        icon: 'ti ti-template', 
        bgColor: 'bg-lightprimary dark:bg-darkprimary', 
        textColor: 'text-primary', 
        key: 'totalSubscriptions', 
        label: 'Total Subscriptions' 
    },

    { 
        icon: 'ti ti-id', 
        bgColor: 'bg-lighterror dark:bg-darkerror', 
        textColor: 'text-error', 
        key: 'totalUserThemes', 
        label: 'Total User Themes' 
    },

    { 
        icon: 'ti ti-user-check', 
        bgColor: 'bg-lightwarning dark:bg-darkwarning', 
        textColor: 'text-warning', 
        key: 'totalSubscribedUsers', 
        label: 'Subscribed Users' 
    }

]
